<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :isShowBtn="false"
      :filterSelects="filterSelects"
      :liveSearching="true"
      :isCreatable="false"
      :dateSort="false"
      :customParams="customParams"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/admin_log";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: ["updated_at", "admin__name", "payload__ip", "updated_info"],
    sortBy: "sequence",
    customParams: {
      time_field: "updated_at",
    },
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "admin",
        placeholder: "篩選使用者",
      },
      {
        conditionKeys: [
          {
            fieldName: "admin",
            conditionName: "admin",
            type: "array",
          },
        ],
        requiredField: "admin",
        label: "",
        type: "date",
        textKey: "name",
        modelName: "start_time",
        placeholder: "選擇起役日期",
        hasNoSearch: true,
        hasAllSelectBtn: true,
        defaultValue: `${new Date().getFullYear() - 1}-${
          new Date().getMonth() + 1
        }-${new Date().getDate()}`,
        getEndDate: function (originData) {
          if (originData) {
            return originData.end_time;
          }
        },
      },
      {
        conditionKeys: [
          {
            fieldName: "admin",
            conditionName: "admin",
            type: "array",
          },
        ],
        requiredField: "admin",
        label: "",
        type: "date",
        textKey: "name",
        modelName: "end_time",
        placeholder: "選擇完畢日期",
        hasNoSearch: true,
        hasAllSelectBtn: true,
        defaultValue: `${new Date().getFullYear()}-${
          new Date().getMonth() + 1
        }-${new Date().getDate()}`,
        getFromDate: function (originData) {
          if (originData) {
            return originData.start_time;
          }
        },
      },
    ],
  }),
};
</script>

<style>
</style>